import React, {useCallback, useEffect, useState} from 'react'
import { useHistory } from 'react-router'

import { useActionApi, usePersistedApi, usePersistedState } from 'hooks'
import { EditedJobPost } from 'components/EditPost'
import { entities } from 'reduxStore'
import Api from 'api'

import AddOfficeLocation from 'components/AddOfficeLocation/AddOfficeLocation'
import OfficeLocation from 'components/EditPost/OfficeLocation'
import FixedLoader from 'components/FixedLoader'
import FixedError from 'components/FixedError'
import Popup from 'components/Popup'
import { navigateToCordovaLocationsScreen } from 'utils/'


export default function EditJobPostOfficeLocationPage() {
	const history = useHistory()
	const { mode }: { mode: 'post' | 'edit' } = history.location.state as any

	const [addLocationPopupOpened, setAddLocationPopupOpened] = useState(false)

	const [locations, locationsLoading, locationsError, getBillingLocations] = usePersistedApi({
		apiMethod: Api.getLocations,
		entityName: entities.dentistBillingLocations,
		initialValue: [],
	})

	const [addOfficeLocationLoading, addOfficeLocationError, addOfficeLocation] = useActionApi({
		apiMethod: Api.addLocation,
		onSuccess: useCallback(() => {
			setAddLocationPopupOpened(false)
			getBillingLocations({})
		}, [getBillingLocations, setAddLocationPopupOpened]),
	})

	const [persistedJob, saveJob] = usePersistedState<EditedJobPost>({
		entityName: entities.editedJobPost,
		initialValue: {},
	})

	useEffect(() => {
		getBillingLocations({})
	}, [])

	return (
		<>
			<Popup
				opened={addLocationPopupOpened}
			>
				<AddOfficeLocation
					onCancel={
						useCallback(() => {
							setAddLocationPopupOpened(false)
						}, [setAddLocationPopupOpened])
					}
					onAdd={useCallback(
						(location) => {
							addOfficeLocation(location)
						}, [addOfficeLocation],
					)}
				/>
			</Popup>
			<OfficeLocation
				mode={mode}
				isNextAvailable={false}

				locations={locations}
				initLocation={persistedJob.location}
				onAddLocation={navigateToCordovaLocationsScreen}

				onNext={(
					{ location },
				) => {
					saveJob({
						...persistedJob,
						location,
					})

					return 'postAvailability'
				}}
			/>
			<FixedLoader
				loading={
					locationsLoading ||
					addOfficeLocationLoading
				}
			/>
			<FixedError
				error={
					locationsError ||
					addOfficeLocationError
				}
			/>
		</>
	)
}
